import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flickity"
export default class extends Controller {
  connect() {
    this.bind_element();
  }

  bind_element() {
    console.log('options', this.options);
    const options = {...this.options, contain: true};

    new Flickity( this.element, options);
    this.element.removeAttribute('data-flickity');
  }

  get options() {
    return this.element.dataset.flickity;
  }
}
